import PlentyApiClient from "./base";

export const openAIApi = {
  createOpenAICredential: (data) => {
    return PlentyApiClient.post("/openai/credentials/", data);
  },

  getOpenAICredentials: () => {
    return PlentyApiClient.get("/openai/credentials/");
  },

  deleteOpenAICredential: (credentialId) => {
    return PlentyApiClient.delete(`/openai/credentials/${credentialId}`);
  },

  updateOpenAICredential: (credentialId, data) => {
    return PlentyApiClient.put(`/openai/credentials/${credentialId}`, data);
  },

  toggleActiveOpenAICredential: (credentialId) => {
    return PlentyApiClient.post(
      `/openai/credentials/${credentialId}/toggle-active`,
    );
  },

  testOpenAICredential: (data) => {
    return PlentyApiClient.post(`/openai/credentials/test`, data);
  },
};
